<template lang="html">
  <div class="center">
    {{ $t('main.notFound') }}
  </div>
</template>

<script>
export default {}
</script>

<style lang="css" scoped>
.center {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
